export default __webpack_public_path__ + "static/media/class_vii_viii_ix.5209abf0.png";